<script lang="ts">
    import { t } from "@lernetz/svelte-translate";
    import Footer from "../../ui/Footer.svelte";

    let code:string;
</script>

<div class="bg-yellow-light h-full w-full fixed inset-0 flex flex-col overflow-y-auto">
    <div class="flex-1 p-20 md:p-40">
        <label for="name" class="size-14 text-grey-1 w-full">
            {$t('enter code')}
          </label>
          <input id="name" type="text" placeholder="code" bind:value={code} class="mt-10 border-blue-light border-2 rounded-lg text-18 px-16 py-8 w-full sm:w-auto"/>
          <a href="/code/{code}" class="bg-blue-main px-16 py-10 text-white rounded-md inline-block mt-12 sm:mt-0">{$t('go')}</a>
    </div>
    <Footer />
</div>
